import { FixQuality } from 'api'

export const clientMarkerColors = {
  [FixQuality.NotFixed]: '#EA4335',
  [FixQuality.DGNSS]: 'gold',
  [FixQuality.RTK_Fixed]: '#01CB09',
  [FixQuality.RTK_Float]: 'orange',
}
